import { FormApi, FormValues, FormError, FormState } from 'informed';

export interface FormDefaultState<Model> {
  formApi?: FormApi<FormValues>;
  formErrors?: {[key: string]: FormError};
  formFields?: Model;
  formHasErrors: boolean;
  formState: FormState<FormValues>;
}

export const formDefaultState: FormState<FormValues> = {
  asyncErrors: {},
  dirty: false,
  error: undefined,
  errors: {},
  invalid: true,
  pristine: false,
  submits: 0,
  touched: {},
  values: {},
};